import { jsx as t } from "react/jsx-runtime";
import { makeClassesByStyles as a } from "../../../../utils/classes.js";
import c from "../../../../assets/a35292b2.image.module.css";
const i = a(c), g = ({ className: m, src: s, alt: e, width: o, height: r }) => /* @__PURE__ */ t("img", { src: s, alt: e, className: i("Image", m), width: o, height: r });
export {
  g as Image
};
